import axios from 'axios';

import { onInitInterceptors } from './interceptors/interceptors-setup';

export const baseURL = process.env.REACT_APP_BASE_URL || "http://localhost:8082";
const API = axios.create({ baseURL });
onInitInterceptors(API);
export default API;
